module.exports = require('./pca');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-pca/src/index.js
 ** module id = 85
 ** module chunks = 0
 **/